/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ReportStorageFromJSON(json) {
    return ReportStorageFromJSONTyped(json, false);
}
export function ReportStorageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'storageId': !exists(json, 'storageId') ? undefined : json['storageId'],
        'webReportId': !exists(json, 'webReportId') ? undefined : json['webReportId'],
        'queueId': !exists(json, 'queueId') ? undefined : json['queueId'],
        'reportDataPath': !exists(json, 'reportDataPath') ? undefined : json['reportDataPath'],
        'reportData': !exists(json, 'reportData') ? undefined : json['reportData'],
        'iPadReportUpdateDate': !exists(json, 'iPadReportUpdateDate') ? undefined : (json['iPadReportUpdateDate'] === null ? null : new Date(json['iPadReportUpdateDate'])),
        'iPadReportUpdateTime': !exists(json, 'iPadReportUpdateTime') ? undefined : json['iPadReportUpdateTime'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}
export function ReportStorageToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'storageId': value.storageId,
        'webReportId': value.webReportId,
        'queueId': value.queueId,
        'reportDataPath': value.reportDataPath,
        'reportData': value.reportData,
        'iPadReportUpdateDate': value.iPadReportUpdateDate === undefined ? undefined : (value.iPadReportUpdateDate === null ? null : value.iPadReportUpdateDate.toISOString()),
        'iPadReportUpdateTime': value.iPadReportUpdateTime,
        'error': value.error,
    };
}
